import React from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Icon, DA_IconNames } from "../Icon/Icon.component";
import S from "./SwipeIndicator.module.scss";

interface SwipeIndicatorProps {
    className?: string;
}

export const SwipeIndicator: React.FC<SwipeIndicatorProps> = ({ className }) => {
    return (
        <div>
            <DA_Icon name={DA_IconNames.Swipe} className={cn(S.icon, className)} />
        </div>
    );
};
